import React from 'react';
import { Input } from 'web-ui-components/lib/atoms/forms';
import { Field as FormField, FieldBody, FieldHeader } from 'web-ui-components/lib/molecules/forms';
import { BlockFieldColumn } from 'web-ui-components/lib/global/layout';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { isValidGlobalBehaviour } from '../../../utils/validation';

const required = value =>
  isValidGlobalBehaviour(value, 'alphaTwoSpaces') ? undefined : 'Required';

const LastName = () => (
  <Content>
    {({ personDetailsLastName = '', firstLastNameError = '' }) => (
      <Field name="lastName" subscription={{ touched: true, error: true }}>
        {({ meta: { touched, error } }) => (
          <FormField>
            <FieldHeader
              name="lastName"
              hasError={touched && !!error}
              title={personDetailsLastName}
              validationMessage={firstLastNameError}
            />
            <FieldBody hasError={touched && !!error}>
              <Field name="lastName" component="input" validate={required}>
                {({ input }) => (
                  <BlockFieldColumn column={6}>
                    <Input name="lastName" type="text" {...input} maxLength={25} />
                  </BlockFieldColumn>
                )}
              </Field>
            </FieldBody>
          </FormField>
        )}
      </Field>
    )}
  </Content>
);

export default LastName;
